.underlay {
    position: fixed;
    inset: 0;
    background: linear-gradient(
        to bottom,
        transparent var(--top-nav-height, 0),
        var(--overlay-black-20) var(--top-nav-height, 0)
    );
    z-index: 9;
}
